var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workspaces-link-container"},[_c('a',{staticClass:"nav-link",attrs:{"href":"/workspaces"}},[_vm._v(" My Workspaces ")])])
}]

export { render, staticRenderFns }